<template lang="pug">
#modal-withdrawal.modal.fade(tabindex='-1' role='dialog')
  .modal-dialog.modal-dialog-centered.my-0.modal-form
    .modal-content-outside.modal-bg
      .modal-content
        .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0(data-dismiss="modal")
          .arrow-left
            i.fas.fa-chevron-left
          .modal-title.text-capitalize {{$t('ui.home')}}
        .d-none.d-md-block.lg-close(data-dismiss='modal')
          i.far.fa-times-circle
        .modal-body
          .text-center
            .text-uppercase.modal-form-title {{$t('ui.withdrawal')}}
          .d-flex.justify-content-center.btn-balance.btn-shadow.w-50.my-4
            div
              .text-white.text-uppercase.text-balance {{$t('ui.balance')}}
              .text-success.balance-value {{ $numeral($store.getters.balance).format("0,0.00") }}
          form
            .px-4
              .input-group.mb-4
                label.px-2.input-field {{$t('ui.amount')}}
                input.text-center.rounded-pill.form-control(type='number' v-model.trim="$v.withdrawAmount.$model" @keypress="$helpers.onlyNumber")
                validation(:value="$v.withdrawAmount" :name="$t('ui.amount')" target="WITHDRAW")
            .text-center
              a.d-inline-block(href='javascript:void(0)' @click.stop="addWithdrawTicket()")
                .text-center.btn.rounded-pill.text-uppercase.btn-main {{$t('ui.withdrawal')}}
</template>
<script>
import { required, minValue } from 'vuelidate/lib/validators'
import validation from "@/library/_validation.vue"
export default {
  components: {
    validation
  },
  data(){
		return{
      withdrawAmount: "",
      feedback: {
        success: true,
        status: ""
      },
			loading: false,
      startRender:false
		}
	},
  validations() {
    return {
      withdrawAmount: {
        required,
        minValue: minValue(1),
      }
    };
  },
  computed:{
		accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
	},
  methods:{
    addWithdrawTicket(){
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if(this.sessionToken) {
          var vm = this
          let member_id = this.accountID
          let amount = this.withdrawAmount
          let auth_token = this.sessionToken
          this.loading = true
          this.$store
            .dispatch("user/addWithdrawTicket", { member_id, amount, auth_token })
            .then(response => {
              this.loading = false
              this.feedback.success = response.success
              this.feedback.status = response.status
              if (this.feedback.success == true) {                 
                this.withdrawAmount = ""
                this.getBalance()
                this.$v.$reset()
                $("#modal-withdrawal").modal("hide")
                this.$router.push({ name: '/statement', params: {target: "pills-transaction-tab"} }).catch(err => {
                  this.$router.replace({ name: "refresh", params: {target: "pills-transaction-tab"} });
                });
                // this.reset()
              } else {
                this.feedback.status = this.$t("error." + response.status)
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {console.log(response)
              this.loading = false
              this.feedback.success = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
              this.feedback.status = this.$t("error." + response.status)
            });
        }
      }
    },
    getBalance() {
      if (this.sessionToken) {
        let member_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBalance", { member_id, auth_token })
          .then(response => {
            if (response.success == true) {
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }else{
              if(response.status.status == 0){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list.disconnect"), "info", this);
                this.$router.push("/").catch(error =>{})
              }
            }
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
  }
}
</script>